import React, { useState, useEffect, useRef } from "react";
import PageTips from './components/PageTips';
import {
  FaSearch,
  FaFolderOpen,
  FaClipboardCheck,
  FaUpload,
  FaHome,
  FaChartBar,
  FaCloud,
  FaPhone,
  FaUser,
  FaChartLine,
  FaFileAlt,
  FaCheckCircle,
  FaSignOutAlt,
  FaBook,
  FaDatabase,
  FaInfoCircle,
  FaMoon,
  FaSun,
  FaExclamationTriangle,
  FaUserFriends,
  FaTimesCircle
} from "react-icons/fa";
import {
  createBrowserRouter,
  RouterProvider,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Search from "./routes/Search";
import Dashboard from "./routes/Dashboard/index";
import Projects from "./routes/Projects";
import CampaignDashboard from "./routes/CampaignDashboard";
import QaEditor from "./routes/QaEditor";
import ScorecardEditor from "./routes/ScorecardEditor";
import ScorecardList from "./routes/ScorecardList";
import TemplateList from "./routes/TemplateList";
import TemplateEditor from "./routes/TemplateEditor";
import TemplateUpload from "./routes/TemplateUpload";
import CampaignList from "./routes/CampaignList";
import CampaignEditor from "./routes/CampaignEditor";
import CampaignDetail from "./routes/CampaignDetail";
import QuickSightEmbed from "./routes/QuickSightEmbed";
import UploadRecs from "./routes/UploadRecordings";
import FileCopy from "./routes/FileCopy";
import Assigned from "./routes/Assigned";
import Disputes from "./routes/Disputes";
import CallAgents from "./routes/CallAgent";
import UserManagement, { AgentManagement } from "./routes/UserManagement";
import Jobs from "./routes/Jobs";
import JobDetail from "./routes/JobDetail";
import useIsAdmin from "./hooks/useIsAdmin";
import useIsQAAgent from "./hooks/useIsQAAgent";
import useIsCallAgent from "./hooks/useIsCallAgent";
import useIsSuperAdmin from "./hooks/useIsSuperAdmin";
import AnimatedSearch from "./components/AnimatedSearch";
import AuditView from "./routes/Audit";
import OverrideDetail from "./routes/OverrideDetail";
import ScheduledJobs from "./routes/ScheduledJobs";
import TranscribeQuota from "./routes/TranscribeQuota";
import Reports from "./routes/Reports";
import ReportDetail from "./routes/ReportDetail";
import HelpPanel from "./components/HelpPanel";
import TourProvider from "./components/TourProvider";
// import KnowledgeBase from "./routes/KnowledgeBase";
import { payloadFromToken, logOut } from "./api/auth";
import { listJobs } from "./api/api";
import { useLocalStorage } from "./common/localStorage";
import { useTheme } from "./common/theme";
import "./common/chartTheme";
import { OverlayTrigger, Tooltip } from "react-bootstrap";


const routes = [
  {
    path: "/search",
    name: "Search",
    Component: Search,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Search", href: "search" }
    ], 
    adm : true,
    sAdm: true
  },
  {
    path: "/dashboard/parsedFiles/search",
    name: "Search",
    Component: Search,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Search", href: "search" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/uploadRecs",
    name: "Upload Recordings",
    Component: UploadRecs,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Upload Recordings", href: "/uploadRecs" }
    ],
    adm : true,
    sAdm: true,
    qa: true
  },
  {
    path: "/jobs/:jobId",
    name: "Job Detail",
    Component: JobDetail,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Jobs", href: "/jobs" },
      { text: "Job Detail", href: "/jobs/:jobId" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/jobs",
    name: "Jobs",
    Component: Jobs,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Jobs", href: "/jobs" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/fileCopy",
    name: "Copy Files",
    Component: FileCopy,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Upload Recordings", href: "/fileCopy" }
    ],
    adm : true,
    sAdm: true
  },
  
  {
    path: "/dashboard/:key*",
    name: "Call Details",
    hide: true,
    Component: Dashboard,
    breadcrumbs: [
      { text: "Home", href: "../../" },
      { text: "Call List", href: "../../" },
      { text: "Call Details", href: "#" },
    ],
    adm : true,
    sAdm: true,
    qa: true,
    callAgent: true
  },
  {
    path: "/projects",
    name: "Create a Campaign",
    Component: Projects,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Campaigns", href: "/projects" },
    ],
    adm : true,
    sAdm: true
  },
  
  {
    path: "/scorecards",
    name: "Manage Scorecards",
    Component: ScorecardEditor,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Manage Scorecards", href: "/scorecards" },
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/scorecards/view",
    name: "Scorecards",
    Component: ScorecardList,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Scorecards", href: "/scorecards/view" },
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/templates",
    name: "Scorecards",
    exact: true,
    Component: TemplateList,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Scorecards", href: "/templates" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/templates/upload",
    name: "Upload Scorecard",
    hide: true,
    Component: TemplateUpload,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Scorecards", href: "/templates" },
      { text: "Upload", href: "#" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/templates/new",
    name: "New Scorecard",
    hide: true,
    Component: TemplateEditor,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Scorecards", href: "/templates" },
      { text: "New", href: "#" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/templates/:name",
    name: "Edit Scorecard",
    hide: true,
    Component: TemplateEditor,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Scorecards", href: "/templates" },
      { text: "Edit", href: "#" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/campaigns",
    name: "Campaigns",
    exact: true,
    Component: CampaignList,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Campaigns", href: "/campaigns" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/campaigns/new",
    name: "New Campaign",
    hide: true,
    Component: CampaignEditor,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Campaigns", href: "/campaigns" },
      { text: "New", href: "#" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/campaigns/:name",
    name: "Edit Campaign",
    exact: true,
    hide: true,
    Component: CampaignEditor,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Campaigns", href: "/campaigns" },
      { text: "Edit", href: "#" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/campaigns/view/:name",
    name: "Campaign Detail",
    exact: true,
    hide: true,
    Component: CampaignDetail,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Campaigns", href: "/campaigns" },
      { text: "Detail", href: "#" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/qa",
    name: "QA",
    Component: QaEditor,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "QA", href: "/qa" },
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/quicksight",
    name: "Dashboard",
    Component: QuickSightEmbed,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Dashboard", href: "/quicksight" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/assigned",
    name: "Assigned to Me",
    Component: Assigned,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Assigned", href: "/assigned" }
    ],
    qa: true
  },
  {
    path: "/disputes",
    name: "Disputes",
    Component: Disputes,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Disputes", href: "/disputes" }
    ],
    adm: true,
    sAdm: true,
    qa: true
  },
  {
    path: "/CallAgent",
    name: "My Calls",
    Component: CallAgents,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "My Calls", href: "/CallAgent" }
    ],
    callAgent: true
  },
  {
    path: "/override-logs",
    name: "Audit",
    Component: AuditView,
    admin: true,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Audit", href: "/override-logs" }
    ],
    adm : true,
    sAdm: true
  },
  {
    path: "/override-logs/detail",
    name: "Override Detail",
    Component: OverrideDetail,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Audit", href: "/override-logs" },
      { text: "Override Detail", href: "/override-logs/detail" }
    ],
    adm : true,
    sAdm: true
  },
{
    path: "/reports",
    name: "Reports",
    Component: Reports,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Reports", href: "/reports" }
    ],
    sAdm: true
  },
  {
    path: "/reports/:reportId",
    name: "Report Detail",
    Component: ReportDetail,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Reports", href: "/reports" },
      { text: "Report Detail", href: "/reports/:reportId" }
    ],
    sAdm: true
  },
  {
    path: "/scheduled-jobs",
    name: "Scheduled Jobs",
    Component: ScheduledJobs,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Scheduled Jobs", href: "/scheduled-jobs" }
    ],
    adm: true,
    sAdm: true
  },
  {
    path: "/users",
    name: "User Management",
    Component: UserManagement,
    admin: true,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "User Management", href: "/users" }
    ],
    sAdm: true
  },
  {
    path: "/agents",
    name: "Agent Management",
    Component: AgentManagement,
    admin: true,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Agent Management", href: "/agents" }
    ],
    sAdm: true
  },
  {
    path: "/transcribe-quota",
    name: "Transcribe Quota",
    Component: TranscribeQuota,
    breadcrumbs: [
      { text: "Home", href: "../" },
      { text: "Transcribe Quota", href: "/transcribe-quota" }
    ],
    sAdm: true
  },
  // {
  //   path: "/assigned",
  //   name: "Assigned to me",
  //   Component: Assigned,
  //   requiredRoles: ["QAAgent"],
  //   Breadcrumb: () => {
  //     return <BreadcrumbGroup
  //       items={[
  //         { text: "Home", href: "../" },
  //         { text: "Assigned to me", href: "/assigned" }
  //       ]}
  //       ariaLabel="Breadcrumbs"
  //     />
  //   }
  // },
  {
    path: "/",
    name: "Campaign Home",
    Component: CampaignDashboard,
    breadcrumbs: [
      { text: "Campaign Home", href: "/" }
    ],
    adm : true,
    sAdm: true
  }
  // {
  //   path: "/",
  //   name: "Call List",
  //   exact: true,
  //   Component: Home,
  //   breadcrumbs: [
  //     // { text: "Home", href: "#" },
  //     { text: "Call List", href: "#" },
  //   ],
  //   adm : true,
  //   sAdm: true
  // }
];

function TopNavigation({ userName, email, toggleSidebar, helpOpen, toggleHelp, theme, toggleTheme }) {
  const navigate = useNavigate();
  const isSAdmin = useIsSuperAdmin()
  const [showAdmin, setShowAdmin] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Click-to-open rather than hover: a hover menu closes the moment the
  // pointer crosses any gap on the way to an item.
  useEffect(() => {
    if (!menuOpen) return;
    const onPointerDown = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
        setShowAdmin(false);
      }
    };
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        setMenuOpen(false);
        setShowAdmin(false);
      }
    };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [menuOpen]);

  const handleLogout = () => {
    logOut();
  };

  return (
    <div className="topbar text-gray-900">
      <div className="flex items-center h-14 px-3 gap-3">
        {/* Small screens only: there the sidebar is a drawer that has to be
            opened and closed. At md and up it's a persistent column with its
            own expand/collapse control, so a hamburger would be a second,
            conflicting way to do the same thing. */}
        <button
          className="md:hidden p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-800 transition-colors focus-ring flex-shrink-0"
          aria-label="Toggle sidebar"
          onClick={toggleSidebar}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2.5 min-w-0 rounded-lg px-1.5 py-1 -mx-1 hover:bg-gray-50 transition-colors focus-ring"
          aria-label="Go to home"
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/cloudza-logo${theme === 'dark' ? '' : '-black'}.png`}
            alt="CloudZA"
            className="h-7 w-auto object-contain flex-shrink-0"
          />
          <span className="hidden md:block h-5 w-px bg-gray-200 flex-shrink-0" aria-hidden="true" />
          <span className="hidden md:block text-[14px] font-semibold tracking-tight text-gray-700 whitespace-nowrap">
            Post-Call Analytics
          </span>
        </button>

        {/* Search sits centered in the slack between the brand and the action
            cluster, so it reads as the bar's focal point. */}
        <div className="flex-1 flex justify-center min-w-0 px-2">
          <AnimatedSearch />
        </div>

        <div className="flex items-center gap-1 flex-shrink-0">

          <button
            data-tour="help-button"
            className={`p-2 rounded-lg transition-colors focus-ring flex-shrink-0 ${helpOpen ? 'bg-cloudza-50 text-cloudza-700' : 'text-gray-500 hover:bg-gray-100 hover:text-gray-800'}`}
            aria-label="Help for this page"
            aria-pressed={helpOpen}
            onClick={toggleHelp}
          >
            <FaInfoCircle className="w-[18px] h-[18px]" />
          </button>

          {/* Separates the page-level action from the account control. */}
          <span className="h-6 w-px bg-gray-200 mx-1.5" aria-hidden="true" />

          <div className="relative" ref={menuRef} data-tour="user-menu">
            <button
              onClick={() => setMenuOpen(v => !v)}
              aria-haspopup="menu"
              aria-expanded={menuOpen}
              className={`flex items-center gap-2.5 pl-1.5 pr-2 py-1.5 rounded-full transition-colors focus-ring text-gray-800 ${menuOpen ? 'bg-gray-100' : 'hover:bg-gray-100'}`}
            >
              <span className="w-8 h-8 rounded-full bg-gradient-to-br from-cloudza-500 to-cloudza-700 ring-2 ring-cloudza-500/25 text-white text-xs font-bold flex items-center justify-center flex-shrink-0 uppercase shadow-sm">
                {(userName || "?").replace(/[^a-zA-Z0-9]/g, " ").trim().split(/\s+/).map(w => w[0]).slice(0, 2).join("")}
              </span>
              <div className="hidden lg:block text-left min-w-0">
                <div className="text-[13px] font-semibold leading-tight truncate max-w-[150px]">{userName}</div>
                <div className="text-[11px] text-gray-500 leading-tight truncate max-w-[150px]" title={email}>{email}</div>
              </div>
              <svg className={`w-3.5 h-3.5 text-gray-400 hidden lg:block transition-transform ${menuOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            
            {menuOpen && (
            <div className="absolute right-0 top-full pt-2 w-60 z-10 dropdown-in" role="menu">
              <div className="bg-white rounded-xl shadow-lg ring-1 ring-black/5 border border-gray-100 overflow-hidden">
                <div className="px-3.5 py-3 border-b border-gray-100">
                  <div className="text-[13px] font-semibold text-gray-900 truncate">{userName}</div>
                  <div className="text-[11px] text-gray-500 truncate">{email}</div>
                </div>
                <div className="p-1.5">
                  <button
                    onClick={toggleTheme}
                    className="w-full flex items-center gap-2.5 text-left px-2.5 py-2 rounded-lg text-[13px] font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                  >
                    {theme === 'dark'
                      ? <FaSun className="text-gray-400 text-[13px] flex-shrink-0" />
                      : <FaMoon className="text-gray-400 text-[13px] flex-shrink-0" />}
                    <span className="flex-1">{theme === 'dark' ? 'Light mode' : 'Dark mode'}</span>
                    <span className="text-[11px] text-gray-400 capitalize">{theme}</span>
                  </button>
                  <button className="w-full flex items-center gap-2.5 text-left px-2.5 py-2 rounded-lg text-[13px] font-medium text-gray-700 hover:bg-gray-50 transition-colors">
                    <FaUser className="text-gray-400 text-[13px] flex-shrink-0" />
                    Profile Settings
                  </button>
                  {isSAdmin && (
                    <>
                      <button
                        onClick={() => setShowAdmin(v => !v)}
                        className="w-full flex items-center gap-2.5 text-left px-2.5 py-2 rounded-lg text-[13px] font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                      >
                        <FaChartLine className="text-gray-400 text-[13px] flex-shrink-0" />
                        <span className="flex-1">Super Admin Settings</span>
                        <svg
                          className={`w-3.5 h-3.5 text-gray-400 transition-transform ${showAdmin ? 'rotate-90' : ''}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </button>
                      {showAdmin && (
                        <button
                          onClick={() => navigate('/users')}
                          className="w-full text-left pl-10 pr-2.5 py-2 rounded-lg text-[13px] font-medium text-gray-600 hover:bg-gray-50 transition-colors"
                        >
                          User Management
                        </button>
                      )}
                    </>
                  )}
                </div>
                <div className="p-1.5 border-t border-gray-100">
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center gap-2.5 text-left px-2.5 py-2 rounded-lg text-[13px] font-medium text-red-600 hover:bg-red-50 transition-colors"
                  >
                    <FaSignOutAlt className="text-red-400 text-[13px] flex-shrink-0" />
                    Sign Out
                  </button>
                </div>
              </div>
            </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// Width of the collapsed icon rail — wide enough for a 36px target plus gutters.
const RAIL_WIDTH = 84;

function SideNavigation({ sidebarOpen, closeSidebar }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [, setActiveHref] = useState(location.pathname);
  const [sidebarWidth, setSidebarWidth] = useLocalStorage('sidebarWidth', 256);
  // Rail by default — the icons plus tooltips carry the navigation, and the
  // reclaimed width goes to the tables and transcripts that need it.
  const [collapsed, setCollapsed] = useLocalStorage('sidebarCollapsed', true);
  const [hiddenSections, setHiddenSections] = useLocalStorage('sidebarHiddenSections', []);
  const [isResizing, setIsResizing] = useState(false);
  const isAdmin = useIsAdmin();
  const isQAAgent = useIsQAAgent();
  const isSAdmin = useIsSuperAdmin()
  const isCallAgent = useIsCallAgent();

  // Processed-jobs badge on the Jobs nav item: poll the jobs list and flag jobs
  // the backend has finished with since the user last looked at the Jobs page.
  // Visiting /jobs clears it. Stored as the list of job ids already seen —
  // operationStatus has no completion timestamp to compare against instead.
  //
  // Keyed on operationStatus, not status: `status` tracks how far QA review has
  // got, so the badge used to announce that assessors had finished rather than
  // that the upload had. The storage key changed with the meaning — reusing the
  // old one would make every already-processed-but-unassessed job look new and
  // light the badge up with a large count on first load.
  const canSeeJobs = isAdmin || isSAdmin;
  const [seenCompletedJobs, setSeenCompletedJobs] = useLocalStorage('jobsProcessedSeen', null);
  const [unseenJobCount, setUnseenJobCount] = useState(0);
  const seenJobsRef = useRef(seenCompletedJobs);
  seenJobsRef.current = seenCompletedJobs;
  // Read inside the poll rather than depended on by it — see the split below.
  const jobsPathRef = useRef(location.pathname);
  jobsPathRef.current = location.pathname;
  const lastCompletedRef = useRef([]);

  // Fetch on an interval only. location.pathname is deliberately NOT a
  // dependency: it used to be, which re-created the effect — and so re-fetched
  // — on every navigation, and (since the localStorage setter was also an
  // unstable dependency) on every render. On /jobs that was a fetch loop, as
  // each poll wrote a fresh array back into state. listJobs() is not cheap:
  // jobs.js derives operationStatus with a tracker query per job returned.
  useEffect(() => {
    if (!canSeeJobs) return undefined;
    let cancelled = false;
    const check = async () => {
      try {
        const data = await listJobs();
        if (cancelled) return;
        // CompletedWithFailures counts as finished — the pipeline is done with
        // it, and it is the outcome most worth surfacing.
        const completed = (data.jobs || [])
          .filter((j) => j.operationStatus === 'Complete'
                      || j.operationStatus === 'CompletedWithFailures')
          .map((j) => j.jobId);
        lastCompletedRef.current = completed;
        // First run ever: baseline silently so pre-existing jobs don't all
        // light up the badge at once.
        if (seenJobsRef.current == null) {
          setSeenCompletedJobs(completed.slice(-300));
          setUnseenJobCount(0);
          return;
        }
        if (jobsPathRef.current.startsWith('/jobs')) {
          const merged = Array.from(new Set([...seenJobsRef.current, ...completed])).slice(-300);
          setSeenCompletedJobs(merged);
          setUnseenJobCount(0);
        } else {
          setUnseenJobCount(completed.filter((id) => !seenJobsRef.current.includes(id)).length);
        }
      } catch (err) {
        // The badge is best-effort — a failed poll must never surface an error.
      }
    };
    check();
    const timer = setInterval(check, 600000);
    return () => { cancelled = true; clearInterval(timer); };
  }, [canSeeJobs, setSeenCompletedJobs]);

  // Clearing the badge on arrival at /jobs is the only part that genuinely
  // depends on the route, and it needs no network call — it reuses whatever the
  // last poll saw.
  useEffect(() => {
    if (!canSeeJobs) return;
    if (!location.pathname.startsWith('/jobs')) return;
    if (seenJobsRef.current == null) return;
    setSeenCompletedJobs(
      Array.from(new Set([...seenJobsRef.current, ...lastCompletedRef.current])).slice(-300)
    );
    setUnseenJobCount(0);
  }, [canSeeJobs, location.pathname, setSeenCompletedJobs]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing) return;
      const newWidth = Math.min(Math.max(e.clientX, 200), 600);
      setSidebarWidth(newWidth);
    };
    const stopResize = () => setIsResizing(false);

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', stopResize);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', stopResize);
    };
  }, [isResizing, setSidebarWidth]);

  useEffect(() => {
    setActiveHref(location.pathname);
  }, [location.pathname]);

  const isActive = (path) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

  const getItemInfo = (href) => {
    switch (href) {
      case '/search': return 'Advanced search';
      case '/dashboard': return 'Analytics overview';
      case '/projects': return 'Manage projects';
      case '/assigned': return 'Your tasks';
      case '/': return 'Campaign Home';
      case '/qa': return 'QA Scorecard';
      case '/scorecards/view': return 'View scorecards';
      case '/quicksight': return 'Dashboard';
      case '/uploadRecs': return 'Upload Recordings';
      case '/fileCopy': return 'Copy Files';
      case '/override-logs': return 'Audit';
      case '/jobs': return 'View upload jobs';
      case '/CallAgent': return 'My Calls';
      case '/disputes': return 'Review disputed assessments';
      case '/scheduled-jobs': return 'Manage automated fetches';
      case '/templates': return 'Manage QA scorecards';
      case '/campaigns': return 'Manage campaigns';
      case '/reports': return 'Generate QA reports';
      case '/users': return 'Manage console users and roles';
      case '/agents': return 'Manage agent emails, hierarchy, and activity';
      case '/transcribe-quota': return 'Daily transcription limits';
      default: return null;
    }
  };

  let navItems = [];

  if (isSAdmin) {
    navItems = [
      { section: "Overview" },
      { path: "/", label: "Campaign Home", short: "Home", icon: <FaHome /> },
      { path: "/quicksight", label: "Dashboard", short: "Dashboard", icon: <FaChartBar /> },
      { path: "/reports", label: "Reports", short: "Reports", icon: <FaCheckCircle /> },
      { section: "Quality" },
      { path: "/search", label: "Search", short: "Search", icon: <FaSearch /> },
      { path: "/templates", label: "Scorecards", short: "Scorecards", icon: <FaFileAlt /> },
      { path: "/campaigns", label: "Campaigns", short: "Campaigns", icon: <FaFolderOpen /> },
      { section: "Operations" },
      { path: "/jobs", label: "Jobs", short: "Jobs", icon: <FaClipboardCheck /> },
      { path: "/scheduled-jobs", label: "Scheduled Jobs", short: "Scheduled", icon: <FaDatabase /> },
      { path: "/uploadRecs", label: "Upload Recordings", short: "Upload", icon: <FaUpload /> },
      { path: "/fileCopy", label: "Cloud Connector", short: "Connector", icon: <FaCloud /> },
      { section: "Administration" },
      { path: "/disputes", label: "Disputes", short: "Disputes", icon: <FaExclamationTriangle /> },
      { path: "/override-logs", label: "Audit", short: "Audit", icon: <FaBook /> },
      { path: "/users", label: "User Management", short: "Users", icon: <FaUser /> },
      { path: "/agents", label: "Agent Management", short: "Agents", icon: <FaUserFriends /> },
      { path: "/transcribe-quota", label: "Transcribe Quota", short: "Quota", icon: <FaChartLine /> },
    ];
  } else if (isAdmin) {
    navItems = [
      { section: "Overview" },
      { path: "/", label: "Campaign Home", short: "Home", icon: <FaHome /> },
      { path: "/quicksight", label: "Dashboard", short: "Dashboard", icon: <FaChartBar /> },
      { path: "/reports", label: "Reports", short: "Reports", icon: <FaCheckCircle /> },
      { section: "Quality" },
      { path: "/search", label: "Search", short: "Search", icon: <FaSearch /> },
      { path: "/templates", label: "Scorecards", short: "Scorecards", icon: <FaFileAlt /> },
      { path: "/campaigns", label: "Campaigns", short: "Campaigns", icon: <FaFolderOpen /> },
      { section: "Operations" },
      { path: "/jobs", label: "Jobs", short: "Jobs", icon: <FaClipboardCheck /> },
      { path: "/scheduled-jobs", label: "Scheduled Jobs", short: "Scheduled", icon: <FaDatabase /> },
      { path: "/uploadRecs", label: "Upload Recordings", short: "Upload", icon: <FaUpload /> },
      { path: "/fileCopy", label: "Cloud Connector", short: "Connector", icon: <FaCloud /> },
      { section: "Administration" },
      { path: "/disputes", label: "Disputes", short: "Disputes", icon: <FaExclamationTriangle /> },
      { path: "/override-logs", label: "Audit", short: "Audit", icon: <FaBook /> },
    ];
  } else if (isQAAgent) {
    navItems = [
      { section: "Workspace" },
      { path: "/assigned", label: "Assigned to me", short: "Assigned", icon: <FaUser /> },
      { path: "/disputes", label: "Disputes", short: "Disputes", icon: <FaExclamationTriangle /> },
      // { path: "/jobs", label: "Jobs", short: "Jobs", icon: <FaClipboardCheck /> },
      { path: "/uploadRecs", label: "Upload Recordings", short: "Upload", icon: <FaUpload /> }
    ];
  } else if (isCallAgent) {
    navItems = [
      { section: "Workspace" },
      { path: "/CallAgent", label: "My Calls", short: "My Calls", icon: <FaPhone /> },
    ];
  }

  const handleNavigation = (path) => {
    setActiveHref(path);
    navigate(path);
    if (window.innerWidth < 768) {
      closeSidebar();
    }
  };

  // navItems is a flat list, so each item's group is whichever section heading
  // most recently preceded it.
  const sectionOf = [];
  let currentSection = null;
  navItems.forEach((item, i) => {
    if (item.section) currentSection = item.section;
    sectionOf[i] = currentSection;
  });

  const toggleSection = (name) =>
    setHiddenSections((current) =>
      current.includes(name) ? current.filter((s) => s !== name) : [...current, name]
    );

  return (
    <>
      {/* Overlay drawer below md, in-flow column at md and up. `fixed` and
          `relative` must never both apply — `relative` would win and keep the
          drawer in the flow on phones, squeezing the page content. */}
      <aside
        className={`fixed inset-y-0 left-0 z-40 bg-white border-r border-gray-200 flex flex-col h-full custom-scrollbar overflow-y-auto transition-transform duration-200 md:z-auto ${
          sidebarOpen
            ? 'translate-x-0 md:relative'
            : '-translate-x-full md:absolute'
        }`}
        style={{ width: collapsed ? RAIL_WIDTH : sidebarWidth, maxWidth: '85vw' }}
      >
        {/* Collapsed to a rail, the product name has nowhere to go — the top
            bar carries it anyway, so it's simply dropped rather than clipped. */}
        {!collapsed && (
          <div className="px-5 pt-5 pb-1">
            <h2 className="text-[13px] font-bold text-gray-900 leading-snug">
              Smart Contact Center Quality Assurance Tool
            </h2>
          </div>
        )}

      <nav className={`flex-1 pb-4 ${collapsed ? 'px-2 pt-4' : 'px-3'}`}>
        <ul>
          {navItems.map((item, index) => {
            if (item.section) {
              const isFirst = index === 0;
              const sectionCollapsed = hiddenSections.includes(item.section);

              // In the rail a rule stands in for the heading. The first group
              // needs none — there's nothing above it to separate from.
              if (collapsed) {
                return isFirst ? null : (
                  <li key={`section-${index}`} className="mx-3 my-2 border-t border-gray-100" aria-hidden="true" />
                );
              }

              return (
                <li key={`section-${index}`}>
                  <button
                    onClick={() => toggleSection(item.section)}
                    aria-expanded={!sectionCollapsed}
                    className={`w-full flex items-center gap-1.5 px-3 pb-1.5 text-[11px] font-semibold uppercase tracking-wider text-gray-400 hover:text-gray-600 transition-colors select-none ${
                      isFirst ? 'pt-2' : 'pt-5'
                    }`}
                  >
                    <svg
                      className={`w-2.5 h-2.5 flex-shrink-0 transition-transform ${sectionCollapsed ? '-rotate-90' : ''}`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" />
                    </svg>
                    <span>{item.section}</span>
                  </button>
                </li>
              );
            }

            // Items belong to the section heading above them, so a collapsed
            // group simply drops its items from the list.
            if (!collapsed && hiddenSections.includes(sectionOf[index])) return null;

            // The rail shows a short label under each icon, so the tooltip
            // carries the full name rather than repeating what's on screen.
            const tooltipText = collapsed ? item.label : getItemInfo(item.path);
            const active = isActive(item.path);
            const showJobsBadge = item.path === '/jobs' && unseenJobCount > 0;
            const navButton = collapsed ? (
              <button
                onClick={(e) => { e.currentTarget.blur(); handleNavigation(item.path); }}
                aria-label={item.label}
                aria-current={active ? 'page' : undefined}
                className={`relative w-full flex flex-col items-center gap-1 py-2 rounded-xl transition-colors duration-150 group ${
                  active
                    ? 'bg-cloudza-50 text-cloudza-700'
                    : 'text-gray-500 hover:bg-gray-50 hover:text-gray-800'
                }`}
              >
                {showJobsBadge && (
                  <span
                    className="absolute top-1 right-2 w-2 h-2 rounded-full bg-amber-500 ring-2 ring-white"
                    aria-label={`${unseenJobCount} job(s) completed since last viewed`}
                  />
                )}
                {React.cloneElement(item.icon, {
                  className: `text-[17px] ${active ? 'text-cloudza-600' : 'text-gray-400 group-hover:text-gray-600'}`,
                })}
                <span className={`text-[10px] leading-none w-full px-0.5 truncate text-center ${active ? 'font-semibold' : 'font-medium'}`}>
                  {item.short || item.label}
                </span>
              </button>
            ) : (
              <button
                onClick={(e) => { e.currentTarget.blur(); handleNavigation(item.path); }}
                aria-current={active ? 'page' : undefined}
                className={`w-full h-9 flex items-center gap-3 px-3 text-left rounded-lg transition-colors duration-150 group text-[13px] ${
                  active
                    ? 'bg-cloudza-50 text-cloudza-700 font-semibold'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 font-medium'
                }`}
              >
                {React.cloneElement(item.icon, {
                  className: `text-[15px] flex-shrink-0 ${active ? 'text-cloudza-600' : 'text-gray-400 group-hover:text-gray-600'}`,
                })}
                <div className="flex-1 truncate">{item.label}</div>
                {showJobsBadge && (
                  <span
                    className="flex-shrink-0 min-w-[18px] h-[18px] px-1 rounded-full bg-amber-500 text-white text-[10px] font-bold flex items-center justify-center"
                    aria-label={`${unseenJobCount} job(s) completed since last viewed`}
                  >
                    {unseenJobCount}
                  </span>
                )}
              </button>
            );

            return (
              <li key={item.path} className="mb-0.5">
                {tooltipText ? (
                  <OverlayTrigger
                    placement="right"
                    delay={{ show: collapsed ? 0 : 250, hide: 0 }}
                    overlay={
                      <Tooltip id={`sidenav-tt-${item.path}`}>
                        {tooltipText}
                      </Tooltip>
                    }
                    popperConfig={{
                      modifiers: [{ name: 'flip', options: { fallbackPlacements: ['top', 'bottom'] } }],
                    }}
                  >
                    {navButton}
                  </OverlayTrigger>
                ) : navButton}
              </li>
            );
          })}
        </ul>
      </nav>
      <div className="px-3 py-3 border-t border-gray-200 mt-auto">
        <button
          onClick={logOut}
          aria-label={collapsed ? 'Logout' : undefined}
          className={`w-full h-9 flex items-center rounded-lg text-[13px] font-medium text-gray-600 hover:bg-red-50 hover:text-red-600 transition-colors group ${
            collapsed ? 'justify-center px-0' : 'gap-3 px-3'
          }`}
        >
          <FaSignOutAlt className="text-[15px] text-gray-400 group-hover:text-red-500 flex-shrink-0" />
          {!collapsed && <span>Logout</span>}
        </button>

        {/* Rail toggle — desktop only. Below md the sidebar is a drawer that
            the top-bar hamburger already opens and closes. */}
        <button
          onClick={() => setCollapsed(v => !v)}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          className={`hidden md:flex w-full h-9 mt-1 items-center rounded-lg text-[13px] font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-800 transition-colors ${
            collapsed ? 'justify-center px-0' : 'gap-3 px-3'
          }`}
        >
          <svg
            className={`w-[15px] h-[15px] flex-shrink-0 transition-transform ${collapsed ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
          </svg>
          {!collapsed && <span>Collapse</span>}
        </button>
      </div>
      {/* Drag-to-resize is meaningless at a fixed rail width. */}
      {!collapsed && (
        <div
          className="hidden md:block absolute top-0 right-0 w-1 h-full cursor-col-resize bg-transparent hover:bg-cloudza-200 transition-colors"
          onMouseDown={() => setIsResizing(true)}
        />
      )}
    </aside>
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-30 md:hidden"
          onClick={closeSidebar}
        />
      )}
    </>
  );
}

// The route table writes crumb targets in three shapes: absolute ("/jobs"),
// bare ("search") and relative-to-root ("../", "../../"). Resolve all of them
// to a real path so a crumb jumps straight to its destination instead of
// stepping back one entry in history.
function resolveCrumbHref(href) {
  if (!href || href === "#") return null;
  if (href.startsWith("/")) return href;
  if (/^(\.\.\/)+$/.test(href)) return "/";
  return `/${href.replace(/^\.\//, "")}`;
}

// Back control for every page except home. Lives in the shell rather than in
// each route, so pages can't drift apart on whether they offer one.
//
// Prefers history when there's somewhere to go back to, since that returns you
// to the list you actually came from (a call opened from Search should go back
// to Search, not to Campaign Home). Falls back to the parent path on a cold
// load — a pasted or bookmarked URL has no history to step back through.
function PageBack() {
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === '/') return null;

  const goBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
      return;
    }
    // Walk up the path until a segment prefix is an actual registered page —
    // the naive parent of /dashboard/{key} is /dashboard, which isn't a route,
    // so on cold loads Back used to land on an error page instead of a list.
    const staticPaths = new Set(routes.filter((r) => !r.path.includes(':')).map((r) => r.path));
    let parent = location.pathname.replace(/\/[^/]+\/?$/, '') || '/';
    while (parent !== '/' && !staticPaths.has(parent)) {
      parent = parent.replace(/\/[^/]+\/?$/, '') || '/';
    }
    navigate(parent);
  };

  return (
    <button
      onClick={goBack}
      className="inline-flex items-center gap-1.5 mb-3 -ml-1 px-2 py-1 rounded-lg text-xs font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800 transition-colors focus-ring"
    >
      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
      </svg>
      Back
    </button>
  );
}

function Breadcrumbs({ items }) {
  const navigate = useNavigate();

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-xs text-gray-500 mb-5">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const target = isLast ? null : resolveCrumbHref(item.href);
        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <svg className="w-3 h-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
              </svg>
            )}
            {target ? (
              <button
                onClick={() => navigate(target)}
                className="hover:text-cloudza-600 transition-colors focus-ring rounded px-0.5 font-medium"
              >
                {item.text}
              </button>
            ) : (
              <span
                aria-current={isLast ? "page" : undefined}
                className={isLast ? "text-gray-800 font-semibold" : ""}
              >
                {item.text}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

// Stays mounted a beat after `alert` clears so it can slide/fade back out
// instead of vanishing — the same enter+exit pattern as the shared Modal.
const TOAST_EXIT_MS = 200;

function Toast({ alert, onDismiss }) {
  const [rendered, setRendered] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (alert) {
      setRendered(alert);
      const raf = requestAnimationFrame(() => setVisible(true));
      return () => cancelAnimationFrame(raf);
    }
    setVisible(false);
    const timeout = setTimeout(() => setRendered(null), TOAST_EXIT_MS);
    return () => clearTimeout(timeout);
  }, [alert]);

  if (!rendered) return null;

  return (
    <div
      className={`fixed z-[100] left-4 right-4 top-16 w-auto sm:left-auto sm:right-5 sm:top-5 sm:w-full sm:max-w-sm transition-all duration-200 ease-out ${
        visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4'
      }`}
      role="status"
      aria-live="polite"
    >
      <div className={`flex items-start gap-3 p-4 rounded-xl border shadow-lg backdrop-blur-sm ${
        rendered.variant === 'error' ? 'bg-red-50/95 border-red-200 text-red-800' :
        rendered.variant === 'warning' ? 'bg-yellow-50/95 border-yellow-200 text-yellow-800' :
        rendered.variant === 'success' ? 'bg-green-50/95 border-green-200 text-green-800' :
        'bg-blue-50/95 border-blue-200 text-blue-800'
      }`}>
        <div className="flex-shrink-0 mt-0.5">
          {rendered.variant === 'error' ? <FaTimesCircle className="text-red-500" /> :
           rendered.variant === 'warning' ? <FaExclamationTriangle className="text-yellow-500" /> :
           rendered.variant === 'success' ? <FaCheckCircle className="text-green-500" /> :
           <FaInfoCircle className="text-blue-500" />}
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="font-medium">{rendered.heading}</h3>
          {rendered.text && <p className="mt-1 text-sm">{rendered.text}</p>}
        </div>
        <button
          onClick={onDismiss}
          aria-label="Dismiss"
          className="flex-shrink-0 text-gray-400 hover:text-gray-600"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}

// Split out so it can call useLocation() without re-rendering on every
// keystroke elsewhere in AppShell. Keying the fade-in wrapper on the full
// path (not just the route pattern)
// makes it replay on every navigation, including moving between records on
// the same route (e.g. one call detail to another), where React would
// otherwise reuse the existing element and the animation wouldn't restart.
function AppRoutes({ isQAAgent, isSAdmin, isAdmin, isCallAgent, setAlert, cognitoUserName, cognitoEmail }) {
  const location = useLocation();

  return (
    <Routes>
      {routes.map(({ path, Component, breadcrumbs, sAdm, adm, qa, callAgent }) => {
        const hasAccess = (qa && isQAAgent) || (sAdm && isSAdmin) || (adm && isAdmin) || (callAgent && isCallAgent);
        const dynamicBreadcrumbs = () => {
          if (qa && isQAAgent) {
            return [
              { text: "Assigned", href: "/assigned" },
              { text: "Call Details", href: "#" },
            ];
          } else if (callAgent && isCallAgent) {
            return [
              { text: "My Calls", href: "/CallAgent" },
              { text: "Call Details", href: "#" },
            ];
          }
          return breadcrumbs; // default for adm/sAdm
        };
        // v5 wildcard `:key*` → v7 splat `/*` (Dashboard reads useParams()['*'])
        const v7Path = path === '/dashboard/:key*' ? '/dashboard/*' : path;
        return (
          <Route
            key={path}
            path={v7Path}
            element={hasAccess ? (
              <div className="fade-in" key={location.pathname}>
                <PageBack />
                <Breadcrumbs items={dynamicBreadcrumbs()} />
                <PageTips className="mb-6" />
                <Component
                  setAlert={setAlert}
                  username={cognitoUserName}
                  userEmail={cognitoEmail}
                />
              </div>
            ) : null}
          />
        );
      })}
    </Routes>
  );
}

// Renders everything that used to live directly inside <Router> — shell
// chrome (nav, sidebar, help panel) plus the routed content. Wrapped by a
// single catch-all data route below rather than a plain <BrowserRouter> so
// that useBlocker (used by useUnsavedChangesGuard) has the data-router
// context it requires; internal routing via <AppRoutes>'s own <Routes> is
// completely unchanged.
function AppShell() {
  const [alert, setAlert] = useState();
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 768);
  const [helpOpen, setHelpOpen] = useState(false);
  const { theme, toggleTheme } = useTheme();
  const isAdmin = useIsAdmin()
  const isQAAgent = useIsQAAgent()
  const isSAdmin = useIsSuperAdmin()
  const isCallAgent = useIsCallAgent()
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setSidebarOpen(true);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onDismiss = () => {
    setAlert(null);
  };

  // Toasts self-clear so a stray success/info message doesn't sit on screen
  // forever — errors stay a little longer since they're more likely worth
  // reading in full. Any setAlert call anywhere in the app restarts the
  // timer, so a fresh message always gets its full display time.
  useEffect(() => {
    if (!alert) return;
    const duration = alert.variant === 'error' ? 7000 : 4500;
    const timer = setTimeout(() => setAlert(null), duration);
    return () => clearTimeout(timer);
  }, [alert]);
  // A ref (not state) guards this — state set inside an effect isn't visible
  // to that same effect's own re-run, so under StrictMode's dev-only double
  // effect invocation the state-based guard let this fire twice, and because
  // it used a hard window.location.href reload, that meant two full-page
  // reloads back to back on every landing-page visit in dev. A ref updates
  // synchronously and is shared across both invocations, so it actually
  // prevents the second run; navigate() replaces the reload with a normal
  // client-side transition, matching how the rest of the app moves between
  // routes.
  const hasRedirectedRef = useRef(false);
  useEffect(() => {
    if (hasRedirectedRef.current) return;
    const pathname = window.location.pathname;

    if (isQAAgent && !isAdmin && !isSAdmin && pathname === '/') {
      hasRedirectedRef.current = true;
      navigate('/assigned', { replace: true });
    } else if (isCallAgent && !isAdmin && !isSAdmin && !isQAAgent && pathname === '/') {
      hasRedirectedRef.current = true;
      navigate('/CallAgent', { replace: true });
    }
  }, [isQAAgent, isAdmin, isSAdmin, isCallAgent, navigate])

  const userToken = localStorage.getItem("id_token");
  // A missing/corrupt id_token would make payloadFromToken throw and
  // white-screen the whole app — fall back to safe empty defaults instead.
  let parsedToken = {};
  try {
    parsedToken = payloadFromToken(userToken) || {};
  } catch (e) {
    console.error("Failed to parse id_token", e);
  }
  const cognitoUserName = parsedToken["cognito:username"] || "Unknown";
  const userGroups = parsedToken["cognito:groups"]
  console.log("group: ", userGroups)
  const cognitoEmail = parsedToken["email"] || "Unknown";



  return (
    <TourProvider>
    <div className="min-h-screen bg-white text-gray-800">
      <TopNavigation
        userName={cognitoUserName}
        email={cognitoEmail}
        toggleSidebar={() => setSidebarOpen((v) => !v)}
        helpOpen={helpOpen}
        toggleHelp={() => setHelpOpen((v) => !v)}
        theme={theme}
        toggleTheme={toggleTheme}
      />

      <HelpPanel open={helpOpen} onClose={() => setHelpOpen(false)} />

      <div className="flex h-[calc(100vh-57px)]">
        <SideNavigation
          sidebarOpen={sidebarOpen}
          closeSidebar={() => setSidebarOpen(false)}
        />

        <main className="flex-1 overflow-y-auto custom-scrollbar bg-[#f7f7fa]">
          <Toast alert={alert} onDismiss={onDismiss} />

          <div className="page-container py-6">
            <AppRoutes
              isQAAgent={isQAAgent}
              isSAdmin={isSAdmin}
              isAdmin={isAdmin}
              isCallAgent={isCallAgent}
              setAlert={setAlert}
              cognitoUserName={cognitoUserName}
              cognitoEmail={cognitoEmail}
            />
          </div>
        </main>
      </div>
    </div>
    </TourProvider>
  );
}

// A single catch-all route so the entire existing shell + AppRoutes tree
// renders unchanged for every path — only the outer router mechanism
// (data router vs. plain BrowserRouter) changes. createBrowserRouter must be
// called once, outside any component, which is why this lives at module scope.
const router = createBrowserRouter([
  { path: "/*", element: <AppShell /> },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;